// import React from 'react'

// const AddSmssetup = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default AddSmssetup
import { useState } from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css'; // MUI-compatible styling

import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
    externalpostApi,
    externalgetApi,
} from "../../services/external/externalApis";

import {
    LOCATION_API_01,

    SHOP_API_01,

    USERS_SMS_SETUP_API_03,
} from "../../api/ApiModel";

import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
function AddSmssetup() {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [data, setData] = useState(null);
  const [datashop, setDatashop] = useState(null);
  const [selectedLOC, setSelectedLOC] = useState("");
  const [selectedSHOP, setSelectedSHOP] = useState("");
  const [selectedLocCode, setSelectedLocCode] = useState("");
  const [selectedrestcode, setSelectedrestcode] = useState("");
  const [locationdata, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [inputUserName, setInputUserName] = useState("");
  const [dataloc, setDataloc] = useState(null);
  const [dataemailaction, setDataemailaction] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dataemail, setDataemail] = useState([]);
  const { state } = useLocation();
  const theme = useTheme();
  const styles = useStyles(theme);


  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    interval: "",
    subject: "",
    bodytext: "",
    
    tono: "",
    sender: "",
  });
  const [imageSrc, setImageSrc] = useState(
    "https://st3.depositphotos.com/3326513/19442/v/450/depositphotos_194428038-stock-illustration-black-linear-photo-camera-logo.jpg" // Default image URL
  );
  const  selectedItem  = location.state?.selectedItem;
const parsed = parseInt(selectedItem.INTERVAL);

useEffect(() => {
  if (selectedItem) {
    setSelectedItemDetails({   
      interval: typeof selectedItem.INTERVAL === "number" ? selectedItem.INTERVAL.toString() : "",

      subject: typeof selectedItem.SUBJECT === "string" ? selectedItem.SUBJECT : "",
      bodytext: typeof selectedItem.BODYTEXT === "string" ? selectedItem.BODYTEXT : "",
      tono: typeof selectedItem.TONO === "string" ? selectedItem.TONO : "",
      sender: typeof selectedItem.SENDER === "string" ? selectedItem.SENDER : "",
    });
  }
}, [selectedItem]);


  useEffect(() => {
    if (selectedItem && selectedItem.IMAGEPATH) {
      setImageSrc(selectedItem.IMAGEPATH);
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchLocationData();
  }, []);

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERNAME, GROUPCODE } = SYS_USER.USER_PARAM || {};

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Only number validation for 'interval'
    if (name === "interval" && value && !/^\d*$/.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        interval: "Only numbers are allowed",
      }));
      return;
    }

    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setInputUserName(value);

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

    const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear any existing error message
      }));
      handleInputChange(event); // Update state with the valid input
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed. Maximum 10 digits.",
      }));
    }
  };
  const handleClearClick = () => {
    //clear text filed function goes here
    setSelectedItemDetails({
      mailaction: "",
      interval: "",
      subject: "",
      bodytext: "",
     
   
      tono: "",
      sender: "",
    });
  };

    const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  const handleConfirmClick = async () => {
    const {
      interval,
      subject,
      bodytext,
      
      tono,
      sender,
    } = selectedItemDetails;

    const requiredFields = [
      { name: "interval", value: interval, label: "Interval" },
     
      { name: "bodytext", value: bodytext, label: "Body Text" },
      
      { name: "tono", value: tono, label: "From No" },
      { name: "sender", value: sender, label: "Sender" },

      // Add more fields as needed
      // { name: "username", value: username, label: "Username" },
    ];

    // Required field validation
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError);
      setSnackbarMessage(`Required fields.`);
      setOpenErrorSnackbar(true);
      return;
    }

  



    // if (dataloc) {
    //   const isDuplicate = dataloc.some((item) => {
    //     if (
    //       item.USERNAME != selectedItemDetails.USERNAME &&
    //       item.USERNAME === USERNAME
    //     ) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    //   if (isDuplicate) {
    //     setSnackbarMessage("User name already exists."); // Show snackbar if duplicate found
    //     setOpenErrorSnackbar(true);
    //     return;
    //   }
    // }
    const staticValues = {
      COMPCODE: COMPCODE,
      LOCCODE: selectedItem.LOCCODE,
      RESTCODE: String(selectedItem.RESTCODE),
      SMSACTIONCODE: parseInt(selectedItem.SMSACTIONCODE),
      SENDSMSCODE: 0,
      SMSACTION: "",
     
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      const jsonString = JSON.stringify(payload);
      console.log("Payload for API call:", jsonString);
      const responseData = await externalpostApi(
        USERS_SMS_SETUP_API_03,
        payload
      );

      //make below 
  if (responseData.message === "Sms setup created successfully.") {
        setTimeout(() => {
          gotToPage();
        }, 2000);
      }
      setSnackbarMessage("SMS Setup Successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SHOP_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
          // CATTYPE: "R",
          STS: CON_STATUS_ACTIVE,
        });
        setDatashop(result);

        console.log("result", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, []);

  // Fetch locations from API
  const fetchLocationData = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
        GROUPCODE: GROUPCODE,
        USERNAME: USERNAME,
      };

      const response = await externalgetApi(LOCATION_API_01, "get", params);
      if (Array.isArray(response)) {
        setLocationData(response);
        // Ensure response is an array
      } else {
        setError("Invalid data format from API.");
        setLocationData([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setError("Failed to fetch locations.");
      setLocationData([]); // Fallback to an empty array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result);
        console.log("Filtered Locations:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchLocations();
  }, []);





  // 2. Update handleSelectionshop to set the business type code

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
      setSelectedLocCode(dataloc[0].LOCCODE); // Set the first item's LOCCODE as the default
    }
  }, [dataloc, selectedLOC]);

  useEffect(() => {
    if (Array.isArray(datashop) && datashop.length > 0 && !selectedSHOP) {
      setSelectedSHOP(datashop[0]); // Set the first shop as default
      setSelectedrestcode(datashop[0].RESTCODE); // Set the first shop's RESTCODE as default
    }
  }, [datashop, selectedSHOP]);

  const gotToPage = () => {
    navigate("/smssetup");
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">SMS Setup</Link>
                <Link underline="none">SMS Setup</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? " SMS Setup" : " SMS Setup" }}
        />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Interval <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="interval"
             value={selectedItemDetails.interval}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.interval)}
              helperText={errors.interval}
            />
          </Grid>
      <Grid item lg={6} md={6} xs={12} sm={12}>
  <div style={{ position: 'relative', marginTop: 0 }}>
    <label
      htmlFor="phone"
      style={{
        position: 'absolute',
        top: -8,
        left: 12,
        backgroundColor: '#fff',
        padding: '0 4px',
        fontSize: 12,
        color: '#555',
        zIndex: 1,
      }}
    >
      To Number <span style={{ color: 'red' }}> *</span>
    </label>

    <PhoneInput
      inputProps={{
        name: 'tono',
        required: true,
        id: 'phone',
      }}
      country={'lk'} // default country
      value={selectedItemDetails.tono}
      onChange={(phone) =>
        setSelectedItemDetails({ ...selectedItemDetails, tono: phone })
      }
      containerStyle={{ width: '100%' }}
      inputStyle={{
        width: '100%',
        height: 40,
        paddingLeft: 48,
        paddingTop: 12,
        paddingBottom: 6,
        fontSize: 14,
      }}
      specialLabel={null}
    />
    {errors.tono && (
      <span style={{ color: 'red', fontSize: '0.75rem' }}>{errors.tono}</span>
    )}
  </div>
</Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Sender Name <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="sender"
              value={selectedItemDetails.sender}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.sender)}
              helperText={errors.sender}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                 Body Text <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              multiline
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="bodytext"
              value={selectedItemDetails.bodytext}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.bodytext)}
              helperText={errors.bodytext}
            />
          </Grid>
         
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            id="btnconfirm"
          >
            {"Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default AddSmssetup;
